// extracted by mini-css-extract-plugin
export var actions = "_14-0";
export var actionsContainer = "_14-6";
export var border = "_14-1";
export var childFullHeight = "_14-d";
export var collapse = "_14-2";
export var content = "_14-8";
export var contentChild = "_14-c";
export var fullscreen = "_14-a";
export var headerContainer = "_14-3";
export var headerRow = "_14-5";
export var hidePadding = "_14-9";
export var noScrollX = "_14-e";
export var noScrollY = "_14-f";
export var optOutTopPadding = "_14-b";
export var pagePadding = "_14-7";
export var profile = "_14-g";
export var profileContainer = "_14-h";
export var profileImage = "_14-i";
export var profileMain = "_14-j";
export var profileSubtitle = "_14-l";
export var profileTitle = "_14-k";
export var tabsWrapper = "_14-4";
export var title = "_14-m";